import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { StudyTimerProvider } from "../../components/study-timer.js";
import { FullPageStatus } from "./login-page.js";
import { sessionQueryOptions } from "./session.js";

export function ProtectedRoute(): React.JSX.Element {
  const location = useLocation();
  const sessionQuery = useQuery(sessionQueryOptions);

  if (sessionQuery.isLoading) {
    return <FullPageStatus message="Checking your private learning space…" />;
  }
  if (sessionQuery.isError) {
    return (
      <FullPageStatus
        message="MemoKite is unavailable right now."
        actionLabel="Try again"
        onAction={() => void sessionQuery.refetch()}
      />
    );
  }
  if (!sessionQuery.data) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <StudyTimerProvider>
      <Outlet />
    </StudyTimerProvider>
  );
}
